import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { AuthService } from '@shared/services/auth/auth.service';
@Component({
  selector: 'app-app-initialization-with-uri',
  templateUrl: './app-initialization-with-uri.page.html',
  styleUrls: ['./app-initialization-with-uri.page.scss']
})
export class AppInitializationWithUriPage implements OnInit, OnDestroy {
  private _shortUrl: string = '';
  private _completeUrl: string = '';
  private completeUrlSubscription: Subscription | undefined;

  public showExpired: boolean = false;

  constructor(private _activeRoute: ActivatedRoute, private _authService: AuthService) { }

  ngOnInit(): void {
    this._shortUrl = this._activeRoute.snapshot.queryParams["lk"];
    this.completeUrlSubscription = this._authService.getCompleteUrl(this._shortUrl).subscribe(response => {
      if (response.Data == null) {
        this.showExpired = true;
      }
      else {
        this.showExpired = false;
        this._completeUrl = response.Data
        setTimeout(() => {                           // <<<---using ()=> syntax
          window.location.href = this._completeUrl;
        }, 3000);
      }
    });
  }

  ngOnDestroy(): void {
    this.completeUrlSubscription?.unsubscribe();
  }
}
